import { useAuth } from '~/store/auth'

export default defineNuxtRouteMiddleware(() => {
  const userStore = useAuth()
  if (userStore.user === null) {
    return navigateTo('/')
  }
})
